export default __webpack_public_path__ + "static/media/logo.37e9c6b1.jpg";